import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Car, Wrench, ArrowRight } from 'lucide-react';

export default function SellChoice() {
  const navigate = useNavigate();

  return (
    <main data-testid="sell-choice-page" className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-20">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-3">What would you like to sell?</h1>
          <p className="text-muted-foreground">Choose the type of listing you want to create</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Sell Car */}
          <button
            onClick={() => navigate('/create-listing')}
            className="group bg-card border border-border/50 hover:border-gold/50 rounded-2xl p-8 text-left transition-all hover:shadow-lg hover:shadow-gold/5"
            data-testid="sell-car-btn"
          >
            <div className="w-16 h-16 rounded-xl bg-gold/10 flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors">
              <Car className="w-8 h-8 text-gold" />
            </div>
            <h2 className="text-xl font-bold mb-2">Sell a Car</h2>
            <p className="text-muted-foreground text-sm mb-6">
              List your vehicle for sale with VIN verification, photos, and AI-powered trust scoring.
            </p>
            <div className="flex items-center text-gold font-medium text-sm group-hover:gap-2 transition-all">
              Create car listing <ArrowRight className="w-4 h-4 ml-1" />
            </div>
          </button>

          {/* Sell Parts */}
          <button
            onClick={() => navigate('/create-part-listing')}
            className="group bg-card border border-border/50 hover:border-gold/50 rounded-2xl p-8 text-left transition-all hover:shadow-lg hover:shadow-gold/5"
            data-testid="sell-parts-btn"
          >
            <div className="w-16 h-16 rounded-xl bg-gold/10 flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors">
              <Wrench className="w-8 h-8 text-gold" />
            </div>
            <h2 className="text-xl font-bold mb-2">Sell Spare Parts</h2>
            <p className="text-muted-foreground text-sm mb-6">
              List car spare parts with compatibility info, photos, and secure escrow payments.
            </p>
            <div className="flex items-center text-gold font-medium text-sm group-hover:gap-2 transition-all">
              Create parts listing <ArrowRight className="w-4 h-4 ml-1" />
            </div>
          </button>
        </div>

        {/* Info Section */}
        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground">
            Both listing types support secure escrow payments and in-app messaging.
          </p>
        </div>
      </div>
    </main>
  );
}
